// extracted by mini-css-extract-plugin
export default {"spacer":"SpacerField_spacer__Elq-B"};